import React from "react";

export default function PdfModal({ open, onClose, pdfBlobUrl, loading }) {
  if (!open) return null;

  return (
    <div className="modal-backdrop pdf-backdrop">
      <div className="pdf-modal">
        <div className="pdf-modal-header">
          <div>
            <h2>Clinical Case Sheet</h2>
            <p className="muted">
              Preview the formatted medical sheet. This can be used like a prescription-style document.
            </p>
          </div>

          <div className="pdf-modal-actions">
            {pdfBlobUrl ? (
              <a
                className="btn btn-secondary"
                href={pdfBlobUrl}
                target="_blank"
                rel="noreferrer"
              >
                Open in New Tab
              </a>
            ) : null}

            <button className="btn btn-ghost" onClick={onClose} type="button">
              Close
            </button>
          </div>
        </div>

        <div className="pdf-frame-wrap">
          {loading ? (
            <div className="pdf-loading">Loading clinical sheet...</div>
          ) : pdfBlobUrl ? (
            <iframe
              title="Clinical Case Sheet PDF"
              src={pdfBlobUrl}
              className="pdf-frame"
            />
          ) : (
            <div className="pdf-loading">Could not load PDF.</div>
          )}
        </div>
      </div>
    </div>
  );
}